import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ApplicationSectionBaseComponent } from '../../../../../applications/components/application-section-base/application-section-base.component';
import { ApplicationState, WorkflowData } from '../../../../../applications/models/applications.models';
import { DomainDefinitionService } from '../../../../../builder/services/domain-definition.service';
import { OrganizationStub } from '../../../../../common/models/organization.model';
import { Well } from '../../../../../common/models/well.model';
import { FormationModel } from '../../../../../form-controls/components/new-casing-plan/models/casing-plan.model';
import { AuthService } from '../../../../../services/auth.service';

@Component({
    selector: 'app-well-information',
    templateUrl: './well-information.component.html',
    styleUrls: ['./well-information.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss'],
    standalone: false
})
export class WellInformationComponent extends ApplicationSectionBaseComponent implements OnInit {
    @Input() application: WorkflowData;

    @Input() form: FormGroup;
    @Input() organization: OrganizationStub;
    @Input() well: Well;

    subscription: Subscription = new Subscription();
    formations: FormationModel[] = [];

    get isInternal(): boolean {
        return this._auth.User.isInternal;
    }

    reviewStates: ApplicationState[] = [
        ApplicationState.VerifyCompletion,
        ApplicationState.InitialReview,
        ApplicationState.InitialApproval,
        ApplicationState.FinalApproval
    ];

    blankFormation: FormationModel = {
        code: "",
        definition: "",
        isActive: true,
        isRequired: false,
        lastModifiedDateUTC: new Date
    }

    get drillingStartDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('drillingStartDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }


    get drillingEndDate(): Date {
        if (this.form == null) return null;
        let ctrl = this.form.get('drillingEndDate');
        if (ctrl == null) return null;
        let value: Date = (ctrl.value != null && ctrl.value != '') ? new Date(ctrl.value) : null;
        return value;
    }


    constructor(public _auth: AuthService, public domainService: DomainDefinitionService) {
        super(_auth);

    }

    ngOnInit() {


        let obs$: Observable<FormationModel[]> = this.domainService.getFormations().pipe(
            tap((models: FormationModel[]) => {
                this.formations = models;
                this.formations.unshift(this.blankFormation);

            })

        );


        let subs$: Subscription = obs$.subscribe()
        this.subscription.add(subs$);

        if (this.application != null) {

            this.form.get("drillingStartDate").setValue(this.application.workflowFieldDatas.find(f => f.formControlName == 'wellInfo|drillingStartDate').dateData);
            this.form.get("drillingEndDate").setValue(this.application.workflowFieldDatas.find(f => f.formControlName == 'wellInfo|drillingEndDate').dateData);



        if (this.application.applicationState == (ApplicationState.InitialReview || ApplicationState.Approved)){
                this.form.disable()
            }

        if (this.isInternal && this.application.applicationState == ApplicationState.Corrections) {
                this.form.disable();
            }

        }
    }

    onDateUpdated(date: Date, field: string): void {
        let ctrl = this.form.get(field);
        if (ctrl != null) ctrl.setValue(date);
    }

}
